<template>
	<modal-container
		ref="modal"
		width="90%"
		maxWidth="700px"
		closeByClickOnOverlay
		closeByClickOnEsc
	>
		<template slot="modal-content">
			<h2 class="center" v-if="order">
				A causa delle festività, la prossima consegna<br> sarà il giorno {{ order.date.delivery | readableDate }}.
			</h2>
			<p class="center">
				Potrai cambiare giorno dal tuo profilo nella sezione "indirizzo e giorno di consegna"
			</p>
		</template>
	</modal-container>
</template>

<script>
import { shipmentDayChanging } from '../../mixins/shipmentDayChanging'
import { orderStore } from '../../store/orderStore'

const moment = require('moment')

export default {
	data () {
		return {
			orderStore: orderStore.state
		}
	},
	filters: {
		readableDate (val) {
			return moment(val).locale('it').format('dddd D MMMM')
		}
	},

	computed: {
		order () {
			return this.orderStore.order
		}
	},

	methods: {
		open () {
			this.$refs.modal.open()
		},

		close () {
			this.$refs.modal.close()
		}
	},

	mounted () {
		
	}
}
</script>

<style scoped>

</style>